const EDGE_OFFSET = 50

export const isExitIntent = (e: MouseEvent): boolean => {
    const element = e.target as HTMLElement

    // If this is an input element.
    if (element.tagName?.toLowerCase() === 'input') return false

    // Get the current viewport width.
    const vpWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)

    // If the current mouse X position is within 50px of the right edge
    // of the viewport, return false.
    if (e.clientX >= vpWidth - EDGE_OFFSET) return false

    // If the current mouse Y position is not within 50px of the top
    // edge of the viewport, return false.
    if (e.clientY >= EDGE_OFFSET) return false

    // If mouse still focused on a html element return false
    if (e.relatedTarget) return false

    return true
}
